<template>
    <div id="modal-share-proj" class="modal fade" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <!-- <div class="modal-header"> -->
                <!--     <h5><i class="fas fa-share-alt"></i>&nbsp;共有</h5> -->
                <!--     <button class="close" type="button" data-dismiss="modal"> -->
                <!--         <span aria-hidden="true">&times;</span> -->
                <!--     </button> -->
                <!-- </div> -->
                <div class="modal-body">
                    <p class="text-center"><small class="text-muted">クリップボードへ<br>コピーする項目を選択してください。</small></p>
                    <ul class="list-group lsit-group-flush">
                        <li class="list-group-item pr-0 border-0">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" v-model="infoChecked" class="custom-control-input" id="proj_simple_info_check" checked>
                                <label class="custom-control-label" for="proj_simple_info_check">
                                    [言語][開始時期][人数]
                                    <span class="text-nowrap">
                                        [最寄り駅]
                                    </span>
                                </label>
                            </div>
                        </li>
                        <li class="list-group-item border-0">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" v-model="nameChecked" class="custom-control-input" id="proj_nm_check" checked>
                                <label class="custom-control-label" for="proj_nm_check">案件名</label>
                            </div>
                        </li>
                        <li class="list-group-item border-0">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" v-model="urlChecked" class="custom-control-input" id="proj_share_url_check" disabled>
                                <label class="custom-control-label" for="proj_share_url_check">案件詳細共有URL</label>
                            </div>
                        </li>
                        <li class="list-group-item border-0 py-0">
                            <div class="row">
                                <div class="col-12 d-flex">
                                    <div class="form-group form-check mb-0 mr-3">
                                        <input type="checkbox" class="form-check-input" id="check-proj-price" v-model.trim="projPrice" :disabled="disablePrice">
                                        <label class="form-check-label" for="check-proj-price"><small>単価</small></label>
                                    </div>
                                    <div class="form-group form-check mb-0 mr-3">
                                        <input type="checkbox" class="form-check-input" id="check-url-mark" v-model.trim="urlMark">
                                        <label class="form-check-label" for="check-url-mark"><small>URLマーク</small></label>
                                    </div>
                                    <div class="form-group form-check mb-0">
                                        <input type="checkbox" class="form-check-input" id="check-see-more" v-model.trim="seeMoreBtn">
                                        <label class="form-check-label" for="check-see-more"><small>もっと見る</small></label>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="list-group-item border-0 py-1">
                            <small><input v-model.trim="markText" type="text" class="form-control" :disabled="!urlMark" maxlength="30" spellcheck=false placeholder="URLマーク"></small>
                        </li>
                        <li class="list-group-item border-0 py-1">
                            <select class="form-control mb-2" v-model.trim="contactBtn">
                                <option value="c0">問い合わせ(なし)</option>
                                <option value="c1">問い合わせ(メール)</option>
                                <option value="c2" disabled>問い合わせ(フォーム)</option>
                            </select>
                        </li>
                        <li class="list-group-item border-0">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" v-model="infoAllChecked" class="custom-control-input" id="proj_info_all">
                                <label class="custom-control-label" for="proj_info_all">案件(全項目)</label>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="modal-footer">
                    <div class="container">
                        <div class="row">
                            <div class="col-6">
                                <button class="btn btn-block m-0 btn-success" type="button" @click="doCopy" :disabled="disableCopy">&nbsp;コピー&nbsp;</button>
                            </div>
                            <div class="col-6">
                                <button class="btn btn-block m-0 btn-primary" type="button" @click="hideThis" >&nbsp;閉じる&nbsp;</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {editProjStartDate} from 'pages/commons/form/comFunc'
    import {converVal} from 'pages/commons/form/selectList'
    import {mapGetters} from 'vuex'

    export default {
        data(){
            return {
                item: {},
                projUrl: "",
                infoChecked:true,
                nameChecked:true,
                urlChecked:true,
                infoAllChecked:false,
                infoStr: "",
                projPrice: false,
                contactBtn: "c0",
                seeMoreBtn: false,
                urlMark: false,
                markText: ""
            }
        },
        watch: {
            infoAllChecked (val) {
                this.infoChecked = !val
                this.nameChecked = !val
                this.urlChecked = !val
                //this.infoStr = val ? this.shareInfoAll : this.shareInfo
                this.projPrice = false
                this.contactBtn = "c0"
                this.seeMoreBtn = false
                this.urlMark = false
                this.markText = ""
            },
            getCustShareUrlLoadStatus (status) {
                if (status == 1) {
                    this.$store.dispatch('startSpinner')
                }
                if (status == 2) {
                    this.projUrl = this.getCustShareUrl.data.cust_proj_share_url
                    this.copyText()
                    this.$store.dispatch('doneSpinner')
                }
                if (status == 3) {
                    this.$store.dispatch('doneSpinner')
                }
            },
        },
        computed: {
            disablePrice () {
                return this.item.proj_price_pub == "1" ? true : false
            },
            disableCopy () {
                if (this.urlMark) {
                    return this.markText == "" ? true : this.checkMark(this.markText)
                }
                return false
            },
            maxPrice () {
                if (this.projPrice) {
                    if (this.item.proj_price_pub == "0" && this.item.proj_price_pub_end != "0") {
                        return "～" + this.item.proj_price_pub_end + "万"
                    }
                }
                return ""
            },
            shareInfo () {
                let info = "";

                if (this.infoChecked) {
                    let priceStr = this.maxPrice != "" ? "[ " + this.maxPrice + " ]" : ""
                    info += priceStr
                    if (this.item.proj_language) {
                        info += "[ " + this.item.proj_language + " ]"
                    }
                    info += "[ " + this.editStartDate(this.item.proj_start_date) + " ]" 
                    if (this.item.proj_members) {
                        info += "[ " + this.item.proj_members + "名 ]"
                    }
                    if (this.item.proj_place) {
                        info += "[ " + this.item.proj_place + " ]"
                    }
                    info += "\n\n"
                }

                if (this.nameChecked) {
                    info += this.item.proj_nm + "\n\n"
                }

                if (this.infoChecked || this.nameChecked) {
                    info += "[ 詳細 ]" + "\n"
                }

                info += this.projUrl

                return info
            },
            shareInfoAll () {
                let item = this.item
                let str = ''
                str += `■案件名：${item.proj_nm}\n`
                str += `■概　要：\n${item.proj_detail}\n`
                str += `■必須スキル：\n${item.proj_skill_need}\n`
                str += item.proj_skill_option ? `■尚可スキル：\n${item.proj_skill_option}\n` : ''
                str += item.proj_remote_ok ? `■リモート：${this.converVal('proj_remote_ok',item.proj_remote_ok)}\n` : ''
                str += item.proj_place ? `■最寄り駅：${item.proj_place}\n` : ''
                str += `■開始時期：${this.converVal('proj_start_date',item.proj_start_date)}\n`
                str += item.proj_members ? `■募集人数：${item.proj_members}名\n` : ''
                str += `■単　　金：`
                if (item.proj_price_pub == '1' || item.proj_price_set == '1') {
                    str += `スキル見合い\n`
                } else {
                    if (item.proj_price_pub_start == item.proj_price_pub_end) {
                        str += `${item.proj_price_pub_end}万円\n`
                    } else {
                        if (item.proj_price_pub_start != 0) {
                            str += `${item.proj_price_pub_start}`
                        }
                        str += `～${item.proj_price_pub_end}万円\n`
                    }

                }
                if (item.proj_is_adjust != '3') {// 3:不明
                    str += `■精算条件：${this.converVal('proj_is_adjust',item.proj_is_adjust)}`
                    str += item.proj_is_adjust == '0' ? `　${item.proj_time_start}～${item.proj_time_end}時間\n` : '\n'
                }
                str += item.proj_foreign_ok ? `■外国籍：${this.converVal('proj_foreign_ok',item.proj_foreign_ok)}\n` : ''
                str += item.proj_start_time ? `■始業時間：${this.converVal('proj_start_time',item.proj_start_time)}\n` : ''
                str += item.proj_interview ? `■面談回数：${item.proj_interview}回\n` : ''
                str += item.proj_min_exper ? `■経験の目安：${item.proj_min_exper}年\n` : ''
                str += item.proj_note ? `■その他：\n${item.proj_note}\n` : ''
                return str
            },
            ...mapGetters(['getCustShareUrl'
                          ,'getCustShareUrlLoadStatus'
            ])
        },
        methods:{
            checkMark (val) {
                let reg = new RegExp(/^[a-zA-Z]*$/)
                return !reg.test(val)
            },
            doCopy () {
                if (this.projPrice || this.contactBtn != "c0" || this.urlMark || this.seeMoreBtn) {
                    this.loadCustShareUrl()
                } else {
                    this.copyText()
                }
            },
            copyText () {
                this.infoStr = this.infoAllChecked ? this.shareInfoAll : this.shareInfo 
                this.$copyText(this.infoStr).then(function (e) {})
                this.hideThis()
            },
            loadCustShareUrl () {
                this.$store.dispatch("loadCustShareUrl", {
                    type:"proj",
                    id: this.item.id,
                    price: this.projPrice,
                    contact: this.contactBtn,
                    seeMore: this.seeMoreBtn,
                    mark: this.urlMark,
                    markText: this.markText
                })
            },
            openThis (item) {
                this.resetThis()
                this.item = Object.assign({}, item)
                this.projUrl = item.proj_signed_url_2
                $('#modal-share-proj').modal('show')
            },
            hideThis () {
                this.resetThis()
                $('#modal-share-proj').modal('hide')
            },
            resetThis () {
                this.item = {}
                this.projUrl = ""
                this.infoChecked = true
                this.nameChecked = true
                this.urlChecked = true
                this.infoAllChecked = false
                this.infoStr = ""
                this.projPrice = false
                this.contactBtn = "c0"
                this.seeMoreBtn = false
                this.urlMark = false
                this.markText = ""
            },
            editStartDate (val) {
                return editProjStartDate(val)
            },
            converVal (name, val) {
                return converVal(name,val)
            },
           // copySuccess () {
           //     this.resetThis();
           // },
        }
    }
</script>
